export default __webpack_public_path__ + "static/media/image8.af72038a.jpg";